// export const API = "http://localhost:4000";
export const API = "https://bulk-email-tool-backend-tawny.vercel.app";
